import * as types from '../mutation-types'
import { httpInstance } from '../../api'

const state = {
  reportPr: [],
  reportPo: []
}
const getters = {
  getPrReport: state => state.reportPr,
  getPoReport: state => state.reportPo
}
const mutations = {
  [types.GET_PR_REPORT] (state, payload) {
    state.reportPr = Object.assign([], payload)
  },

  [types.GET_PO_REPORT] (state, payload) {
    state.reportPo = Object.assign([], payload)
  }
}
const actions = {
  async searchPO ({ commit }, payload) {
    if (payload.company) {
      commit(types.SET_LOADING, true)
      let offset = (payload.page - 1) * 20
      let company = payload.company === 'CMI' ? 'CMCR' : payload.company
      await httpInstance
        .get(
          `purchase/order/admin/report-summary?company=${company}&division=${
            payload.division
          }&department=${payload.department}&plant=${payload.plant}&from_date=${
            payload.from_date
          }&to_date=${payload.to_date}&offset=${offset}`
        )
        .then(response => {
          commit(types.GET_PO_REPORT, response.data)
          commit(types.SET_LOADING, false)
        })
        .catch(error => {
          console.log(error.response)
          commit(types.LOAD_RESPONSE, error.response)
          commit(types.SET_LOADING, false)
        })
    }
  },

  async searchPR ({ commit }, payload) {
    if (payload.company) {
      commit(types.SET_LOADING, true)
      let offset = (payload.page - 1) * 20
      let company = payload.company === 'CMI' ? 'CMCR' : payload.company
      await httpInstance
        .get(
          `purchase/requisition/admin/report-summary?company=${company}&division=${
            payload.division
          }&department=${payload.department}&plant=${payload.plant}&from_date=${
            payload.from_date
          }&to_date=${payload.to_date}&offset=${offset}`
        )
        .then(response => {
          commit(types.GET_PR_REPORT, response.data)
          commit(types.SET_LOADING, false)
        })
        .catch(error => {
          console.log(error.response)
          commit(types.LOAD_RESPONSE, error.response)
          commit(types.SET_LOADING, false)
        })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js